/**
 * Salvare per modul — Configurare interfață client.
 * Reutilizează funcțiile existente din settings / admin UI.
 */
import { getCurrentUser } from './auth.js?v=83.21';
import {
  saveLocationHoursSettings,
  saveContactModuleSettings,
  saveLocationMapSettings,
  saveLocationLogoSettings,
  saveEventModuleSettings,
  saveClientInterfaceModulePartial
} from './settings.js?v=83.21';
import { saveMenuModuleSettings } from '../ui/menu-module-admin.js?v=83.21';

const MODULE_HANDLERS = {
  images: () => saveClientInterfaceModulePartial('images'),
  'social-media': () => saveClientInterfaceModulePartial('social-media'),
  feedback: () => saveClientInterfaceModulePartial('feedback'),
  'location-menu': () => saveMenuModuleSettings({ quiet: true }),
  'wifi-info': () => saveClientInterfaceModulePartial('wifi-info'),
  'community-page': () => saveClientInterfaceModulePartial('community-page'),
  'client-promo-gallery': () => saveClientInterfaceModulePartial('client-promo-gallery'),
  admin: () => saveClientInterfaceModulePartial('admin'),
  prizes: () => saveClientInterfaceModulePartial('prizes'),
  'advanced-claims': async () => {
    const { persistAdvancedClaimsModuleSettings } = await import('../ui/admin.js?v=83.21');
    await persistAdvancedClaimsModuleSettings();
  },
  noWin: () => saveClientInterfaceModulePartial('noWin'),
  'location-hours': () => saveLocationHoursSettings({ quiet: true }),
  reservation: () => saveContactModuleSettings({ quiet: true }),
  'location-map': () => saveLocationMapSettings({ quiet: true }),
  'location-logo': () => saveLocationLogoSettings({ quiet: true }),
  'event-module': () => saveEventModuleSettings({ quiet: true })
};

export async function saveClientInterfaceModuleSettings(moduleId) {
  const id = String(moduleId || '').trim();
  const handler = MODULE_HANDLERS[id];
  if (!handler) {
    throw new Error(`Modul necunoscut: ${id}`);
  }
  const user = getCurrentUser();
  if (!user) {
    throw new Error('Nu ești logat');
  }
  await handler();
}
